module.exports = __webpack_public_path__ + "images/briefing-missing-16f790dd4623cc49e844a81d0a9fd787.svg";